import { Component } from "@angular/core";
import { BaseFieldComponent } from "../base-field/base-field.component";
import { CustomFieldComponentInterface } from "./custom-field-component.interface";
import type { CustomFieldMetaDataInterface, OrchestratorViewModelInterface } from '@nts/std/interfaces';
import { FieldTypes } from "@nts/std/types";

@Component({
    template: '',
    selector: 'nts-custom-field'
})
export abstract class CustomFieldComponent extends BaseFieldComponent implements CustomFieldComponentInterface {

    override type = FieldTypes.Custom;
    abstract get uniqueId();
    abstract initComponentFromMetaData(metaData: CustomFieldMetaDataInterface, ovm: OrchestratorViewModelInterface);
}
